/**
 * FBSBancaSUMAK
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface PagoFacilito { 
    secuencialRespuestaPago?: number;
    secuencialEnvioPago?: number;
    valorPagado?: number;
    valorComisionProducto?: number;
    fechaTransaccion?: string;
    documento?: string;
    codigoResultado?: string;
    fechaTransaccionFinancial?: string;
    horaTransaccion?: string;
    mensaje?: string;
}
